const markerFragment =  `<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
                               height="100" width="100"  fill="rgb(255,136,117)" xml:space="preserve">
                            <title>React.bg</title>
                            <g>
                                <g>
                                    <circle cx="50" cy="50" r="40" stroke="rgb(208, 111, 95)" stroke-width="5" fill="rgb(255,136,117)"/>
                                </g>
                            </g>
                            </svg>`;

export default markerFragment;